import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "../Common/withRouter";
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";
import { Link } from "react-router-dom";
import images from "../../assets/images";

const Sidebar = (props) => {
  // console.log("route", props.route);
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/" className="logo logo-dark">
                <img
                  src={images.logo}
                  style={{ height: 56, width: 55.45, borderRadius: 4 }}
                />
              </Link>
            </li>
          </ul>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? (
            <SidebarContent
              sidebarRoute={props.route}
              activeRoute={props.activeRoute}
            />
          ) : (
            <SidebarContent sidebarRoute={props.route} />
          )}
        </div>
        <div className="sidebar-background"></div>
        <div
          style={{
            position: "absolute",
            bottom: "0px",
            fontSize: "14px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            backgroundColor: "white",
            textAlign: "center",
            padding: "2px 0",
            zIndex: 10,
            backgroundColor: "#0E0E0E",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              margin: 0,
            }}
          >
            {process.env.REACT_APP_VERSION}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
